<div class="latest-post-row" [class.last-item]="isLastItem" [class.print-mode]="printMode" 
  [class.even]="index % 2 === 0" (click)="openPostPage()">
  <div class="latest-post-col index">
    <span>{{index + 1}}</span>
  </div>

  <div class="latest-post-col image">
    <div class="image-container">
      <blurry-backdrop-image [image]="post.imageUrl"></blurry-backdrop-image>
    </div>
  </div>

  <div class="latest-post-col influencer-post">
    <div class="influencer-post-container">
      <div class="text-part">
        <div class="post-title clickable">
          <div>{{post.title}}</div>
        </div>
        <span class="post-date">{{formatPublishDate(post.date)}}</span>
      </div>
      <div class="image-part">
        <img src="{{getPlatformIcon(post.platform)}}" onerror="this.onerror=null;this.src='assets/images/No_Image.png'" width="20" height="20">
      </div>
    </div>
  </div>

  <div class="latest-post-col statistics">
    <span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_reach' | translate}}">
      {{post.reach | thousandNumberSuffix:1}}
    </span>
  </div>

  <div class="latest-post-col statistics">
    <span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_interaction' | translate}}">
      <ng-container *ngIf="post.interaction === null">-</ng-container>
      <ng-container *ngIf="post.interaction !== null">{{post.interaction | thousandNumberSuffix:1}}</ng-container>
    </span>
  </div>

  <div class="latest-post-col statistics">
    <span placement="bottom" ngbTooltip="{{'info_box.influencer.insight_impact' | translate}}">
      {{post.impact | percentNumberSuffix}}
    </span>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-overview/latest-posts/latest-post-item/latest-post-item.component.html